import React, { useEffect, useRef } from "react";
import './Testimonial.css'

export const Testimonials = () => {
  const sliderRef = useRef(null);
  const intervalRef = useRef(null);
  
  // Default Indian testimonials data
  const indianTestimonials = [
    {
      name: "Rajesh Sharma",
      text: "TechnoSun installed solar panels for my home in Ghaziabad. Our electricity bill has reduced by 80% and the service was excellent!",
      img: "https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80",
      location: "Ghaziabad, UP"
    },
    {
      name: "Priya Patel",
      text: "The commercial solar solution for our textile shop in Noida has been fantastic. Great after-sales support and quick installation.",
      img: "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80",
      location: "Noida, UP"
    },
    {
      name: "Amit Singh",
      text: "As a school principal, I'm thrilled with our solar installation. We're saving ₹25,000 monthly and teaching students about renewable energy.",
      img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80",
      location: "Delhi"
    },
    {
      name: "Neha Gupta",
      text: "TechnoSun's solar water heater has been a game-changer for our family. 24/7 hot water with zero electricity cost. Highly recommended!",
      img: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80",
      location: "Faridabad, HR"
    },
    {
      name: "Vikram Joshi",
      text: "The industrial solar plant for our factory has exceeded expectations. ROI came in just 3 years instead of projected 5. Professional team!",
      img: "https://images.unsplash.com/photo-1542178243-bc20204b769f?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80",
      location: "Gurugram, HR"
    },
    {
      name: "Ananya Reddy",
      text: "Excellent rooftop solar installation for our apartment complex. TechnoSun handled all paperwork for government subsidies efficiently.",
      img: "https://images.unsplash.com/photo-1554151228-14d9def656e4?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80",
      location: "Hyderabad, TS"
    }
  ];

  // Auto-scroll functionality
  useEffect(() => {
    const slider = sliderRef.current;
    let scrollAmount = 0;
    const cardWidth = 350; // Approximate width of each testimonial card
    
    const autoScroll = () => {
      if (slider) {
        scrollAmount += cardWidth;
        if (scrollAmount >= slider.scrollWidth - slider.clientWidth) {
          scrollAmount = 0; // Reset to start
        }
        slider.scrollTo({
          left: scrollAmount,
          behavior: 'smooth'
        });
      }
    };

    intervalRef.current = setInterval(autoScroll, 3000); // Scroll every 3 seconds

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  return (
    <div id="testimonials" className="testimonial-section">
      <div className="container">
        <div className="section-title text-center">
          <h2>What Our Clients Say</h2>
          <p className="section-subtitle">Hear from our satisfied customers across India</p>
        </div>
        
        <div className="testimonial-slider-container">
          <div 
            className="testimonial-slider"
            ref={sliderRef}
            onMouseEnter={() => clearInterval(intervalRef.current)}
            onMouseLeave={() => {
              intervalRef.current = setInterval(() => {
                const slider = sliderRef.current;
                if (slider) {
                  const scrollAmount = slider.scrollLeft + 350;
                  slider.scrollTo({
                    left: scrollAmount,
                    behavior: 'smooth'
                  });
                }
              }, 3000);
            }}
          >
            {indianTestimonials.map((d, i) => (
              <div key={`${d.name}-${i}`} className="testimonial-card">
                <div className="testimonial">
                  <div className="testimonial-image">
                    <img src={d.img} alt={d.name} className="img-circle" />
                  </div>
                  <div className="testimonial-content">
                    <p className="testimonial-text">"{d.text}"</p>
                    <div className="testimonial-meta">
                      <strong>- {d.name}</strong>
                      <div className="testimonial-location">
                        <i className="fa fa-map-marker-alt"></i> {d.location}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};